/* eslint-disable */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

/*import url and gateway methods */
import { getData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import AddUpdateQuestionPopup from "../Popup/AddUpdateQuestionPopup";
import DeleteModal from "../Modals/DeleteModal";
import DeleteMessageModal from "../Modals/DeleteMessageModal";
import { assetImages } from "constants";
import SurveyCommonHeader from "components/SurveyComponents/Header/SurveyCommonHeader";

const SurveyQuestionBody = ({ moduleName = "" }) => {
  const token = localStorage.getItem("token");
  const params = useParams();

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");
  const { t } = useTranslation(); //for translation

  const [name, setname] = useState("");

  const [questionTypes, setquestionTypes] = useState([]);
  const [questionList, setQuestionList] = useState([]);
  const [editedQuestionId, setEditedQuestionId] = useState(null);
  const [deleteQuestionId, setDeleteQuestionId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isDataReady, setIsDataReady] = useState(false);

  /*----brcmbxt----*/ /* ---- bread crumb text ---- */
  const breadcrumbText = [
    { title: t("Survey"), link: "/admin/survey/list" },
    { title: `Question / ${name}` },
  ];

  //function for get survey details
  const getSurveyDetails = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SURVEY_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      // console.log(response);
      if (response.status) {
        setname(response.data.name);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for get all question types
  const getAllQuestionTypes = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_QUESTIONTYPES + `?token=${token}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setquestionTypes(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for get all questions from survey details
  const getAllQuestions = async () => {
    setIsLoading(true);
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_SURVEY_DETAILS +
        `/${params.id}` +
        `?token=${token}`;

      const response = await getData(requestUrl);

      // console.log(response);
      if (response.status) {
        setQuestionList(response.data?.questionlist);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  //function for cancel delete
  const cancelDeleteHandler = () => {
    setDeleteQuestionId(null);
  };

  //function for delete question from survey
  const deleteQuestionHandler = async () => {
    try {
      let questionData = {
        surveyid: params.id,
        questionid: deleteQuestionId,
      };

      let requestUrl =
        url.API_BASE_URL + url.API_DELETE_QUESTION + `?token=${token}`;

      const response = await putData(requestUrl, questionData);

      if (response.status) {
        setDeleteQuestionId(null);
        let myModal = new bootstrap.Modal(
          document.getElementById("deleteSuccessModal")
        );
        myModal.show();
      }
    } catch (error) {
      console.log(error.message);
    }
  };

  useEffect(() => {
    // getSurveyDetails();
    // getAllQuestionTypes();
    // getAllQuestions();

    const initializeData = async () => {
      await getSurveyDetails();
      await getAllQuestionTypes();
      await getAllQuestions();
      setIsDataReady(true);
    };

    initializeData();
  }, [params.id]);

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_SURVEY")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pt-2 pt-lg-0 pb-5">
          {/* --- survey question / responses common header start --- */}
          <SurveyCommonHeader moduleName={moduleName} />
          {/* --- survey question / responses common header end --- */}

          <div className="container-fluid pt-4 pt-md-0 px-lg-5">
            {/* --- bread crumb start --- */}
            <BreadCrumb breadCrumbText={breadcrumbText} />
            {/* --- bread crumb end --- */}

            {/* --- survey container start ---- */}
            <div className="survey-container mt-4">
              {!isDataReady || isLoading ? (
                <div className="placeholder-glow">
                  <div className="placeholder col-12 py-5 mb-4"></div>
                  <div className="placeholder col-12 py-5 mb-4"></div>
                  <div className="placeholder col-12 py-5 mb-4"></div>
                </div>
              ) : questionList.length === 0 ? (
                /* Empty State */
                <div className="empty-state-card bg-white border border-gray-300 rounded-3 shadow-sm p-5 text-center mb-4">
                  <div className="empty-state-content">
                    <div className="empty-state-icon mb-4">
                      <div
                        className="icon-wrapper d-inline-flex align-items-center justify-content-center bg-gray-200 rounded-circle"
                        style={{ width: "80px", height: "80px" }}
                      >
                        <span
                          className="material-symbols-outlined text-gray-500"
                          style={{ fontSize: "36px" }}
                        >
                          quiz
                        </span>
                      </div>
                    </div>
                    <h4 className="mb-3 fw-semibold text-dark">
                      No Questions Yet
                    </h4>
                    <p className="mb-4 text-gray-500">
                      Start building your survey by adding your first question.
                      You can create different types of questions to gather the
                      information you need.
                    </p>
                    <Link
                      to="#"
                      className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasSurveyQuestion"
                      aria-controls="offcanvasSurveyQuestion"
                    >
                      <span className="material-symbols-outlined icon-sm">
                        add
                      </span>
                      <span className="fw-semibold">
                        {t("Add Your First Question")}
                      </span>
                    </Link>
                  </div>
                </div>
              ) : (
                questionList.map((question, index) => {
                  return (
                    <div
                      className="question-card bg-white border border-gray-300 rounded-3 shadow-sm mb-4 overflow-hidden"
                      key={index}
                    >
                      {/* Question Header */}
                      <div className="question-header bg-light border-bottom border-gray-300 p-3 p-lg-4">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center gap-3">
                            <div className="drag-handle text-gray-500 cursor-pointer">
                              <span className="material-symbols-outlined icon-lg">
                                drag_indicator
                              </span>
                            </div>
                            <div className="question-type-badge">
                              <span className="badge bg-primary text-white px-3 py-2 rounded-pill fs-sm fw-semibold">
                                {question?.questiontype?.name}
                              </span>
                            </div>
                            <div className="question-number">
                              <span className="text-gray-500 fs-sm fw-semibold">
                                Question #{index + 1}
                              </span>
                            </div>
                          </div>
                          <div className="question-actions d-flex align-items-center gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-primary d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              data-bs-toggle="offcanvas"
                              data-bs-target="#offcanvasSurveyQuestion"
                              aria-controls="offcanvasSurveyQuestion"
                              onClick={() => {
                                setEditedQuestionId(question._id);
                              }}
                              title="Edit Question"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                edit
                              </span>
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              data-bs-toggle="modal"
                              data-bs-target="#deleteQuestionModal"
                              aria-controls="deleteQuestionModal"
                              onClick={() => {
                                setDeleteQuestionId(question._id);
                              }}
                              title="Delete Question"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                delete
                              </span>
                            </button>
                            <button
                              className="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center"
                              style={{ width: "36px", height: "36px" }}
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapse${index}`}
                              aria-expanded="true"
                              aria-controls={`#panelsStayOpen-collapse${index}`}
                              title="Toggle Question Details"
                            >
                              <span className="material-symbols-outlined icon-sm">
                                expand_more
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Question Content */}
                      <div
                        id={`panelsStayOpen-collapse${index}`}
                        className="collapse show"
                      >
                        <div className="question-content p-3 p-lg-4">
                          {/* Question Name Section */}
                          <div className="question-section mb-4">
                            <div className="section-header d-flex align-items-center gap-2 mb-3">
                              <span className="material-symbols-outlined text-primary icon-md">
                                quiz
                              </span>
                              <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                Question
                              </h6>
                            </div>
                            <div className="section-content bg-gray-200 rounded-2 p-3">
                              <p className="mb-0 fs-lg fw-semibold text-dark">
                                {question.name}?
                              </p>
                            </div>
                          </div>

                          {/* Correct Answer Section */}
                          <div
                            className={
                              question.correctanswer === ""
                                ? "d-none"
                                : "answer-section mb-4"
                            }
                          >
                            <div className="section-header d-flex align-items-center gap-2 mb-3">
                              <span className="material-symbols-outlined text-success icon-md">
                                check_circle
                              </span>
                              <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                Correct Answer
                              </h6>
                            </div>
                            <div className="section-content">
                              <div className="answer-badge bg-success bg-opacity-10 border border-success border-opacity-25 rounded-2 p-3">
                                <p className="mb-0 fs-md fw-semibold text-success d-flex align-items-center gap-2">
                                  <span className="material-symbols-outlined icon-sm">
                                    verified
                                  </span>
                                  {question.correctanswer}
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* Options Section */}
                          {question.answers && question.answers.length > 0 && (
                            <div className="options-section">
                              <div className="section-header d-flex align-items-center gap-2 mb-3">
                                <span className="material-symbols-outlined text-warning icon-md">
                                  list
                                </span>
                                <h6 className="mb-0 fs-md fw-semibold text-gray-600">
                                  Answer Options
                                </h6>
                              </div>
                              <div className="section-content">
                                <div className="options-grid row g-2">
                                  {question.answers.map((item, index2) => {
                                    const isCorrect =
                                      item === question.correctanswer;
                                    return (
                                      <div className="col-md-6" key={index2}>
                                        <div
                                          className={`option-item p-3 rounded-2 border ${
                                            isCorrect
                                              ? "bg-success bg-opacity-10 border-success border-opacity-25"
                                              : "bg-gray-200 border-gray-300"
                                          }`}
                                        >
                                          <div className="d-flex align-items-center gap-2">
                                            <span
                                              className={`material-symbols-outlined icon-sm ${
                                                isCorrect
                                                  ? "text-success"
                                                  : "text-gray-500"
                                              }`}
                                            >
                                              {isCorrect
                                                ? "radio_button_checked"
                                                : "radio_button_unchecked"}
                                            </span>
                                            <span
                                              className={`fs-sm fw-medium ${
                                                isCorrect
                                                  ? "text-success"
                                                  : "text-dark"
                                              }`}
                                            >
                                              {item}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
              {/* Add Question Section */}
              <div
                className={
                  questionList.length === 0
                    ? "d-none"
                    : "add-question-section mt-5"
                }
              >
                <div className="add-question-card bg-white border border-gray-300 rounded-3 shadow-sm p-4 text-center">
                  <div className="add-question-content">
                    <div className="add-question-icon mb-3">
                      <div
                        className="icon-wrapper d-inline-flex align-items-center justify-content-center bg-primary bg-opacity-10 rounded-circle"
                        style={{ width: "60px", height: "60px" }}
                      >
                        <span
                          className="material-symbols-outlined text-primary"
                          style={{ fontSize: "28px" }}
                        >
                          add_circle
                        </span>
                      </div>
                    </div>
                    <h5 className="mb-2 fw-semibold text-dark">
                      Add New Question
                    </h5>
                    <p className="mb-4 text-gray-500 fs-sm">
                      Create a new question to enhance your survey and gather
                      valuable insights.
                    </p>
                    <Link
                      to="#"
                      className="btn btn-primary d-inline-flex align-items-center gap-2 px-4 py-2"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasSurveyQuestion"
                      aria-controls="offcanvasSurveyQuestion"
                    >
                      <span className="material-symbols-outlined icon-sm">
                        add
                      </span>
                      <span className="fw-semibold">{t("Add Question")}</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {/* --- survey container end ---- */}
          </div>
        </section>

        {/* ==== modals and popup section === */}
        {/* delete question modal */}
        <DeleteModal
          onDelete={deleteQuestionHandler}
          onCancelDelete={cancelDeleteHandler}
        />

        <AddUpdateQuestionPopup
          questionTypes={questionTypes}
          afterPopupClose={getAllQuestions}
          selectedQuestionId={editedQuestionId}
          setSelectedQuestionId={setEditedQuestionId}
        />

        <DeleteMessageModal afterModalClose={getAllQuestions} />
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default SurveyQuestionBody;
